import $ from 'jquery';

$(document).ready(() => {
	
	var $overlay = $('#overlay');

	$('#hcpYes').on('click',removeOverlay);

	if($overlay.length && $overlay.data('overlay-auto') && sessionStorage.getItem('overlay') === null){
		$overlay.addClass('show');
	}

	function removeOverlay() {
		sessionStorage.setItem('overlay',true);
		$overlay.removeClass('show');
	}

})